import kebabCase from 'lodash/kebabCase';

export function getAlbumTitleTranslationKey(name: string): string {
  return `album-${kebabCase(name)}`;
}
